import { isJoyOwnedGuestPath } from '@shared/utils/websiteV2/joyOwnedGuestPath';

/**
 * Whether `/:handle/<pageSlug>` is one of Joy's own guest flows (RSVP, …) rather than a site page.
 * A `/:handle/page/<slug>` custom page is always the site's, whatever its slug.
 */
export const isJoyOwnedGuestPage = (pageSlug: string | undefined, isUrlBasedCustomPageSlug: boolean): boolean =>
  !!pageSlug && !isUrlBasedCustomPageSlug && isJoyOwnedGuestPath(pageSlug);

export type WebsiteV2GuestGateDecision = Readonly<{
  /** Render the "Site Under Construction" placeholder for everyone, admins included. */
  isUnpublishedHardStop: boolean;
  /** The published state the charm unpublished gate should use. */
  isWebsitePublished: boolean;
}>;

/**
 * A site page of a V2 event only reaches charm when the server found no carbon site this viewer may
 * see, so it hard-stops. A Joy-owned flow is never proxied, so it reaches charm whatever the site's
 * state: it renders, behind the ordinary charm gate fed the carbon site's real published state.
 */
export const deriveWebsiteV2GuestGate = (
  input: Readonly<{ isWebsiteV2: boolean; isPreviewing: boolean; isJoyOwnedPage: boolean; isWebsiteV2Published: boolean; isLegacyPublished: boolean }>,
): WebsiteV2GuestGateDecision => {
  const { isWebsiteV2, isPreviewing, isJoyOwnedPage, isWebsiteV2Published, isLegacyPublished } = input;
  if (!isWebsiteV2) return { isUnpublishedHardStop: false, isWebsitePublished: isLegacyPublished };
  return {
    isUnpublishedHardStop: !isPreviewing && !isJoyOwnedPage,
    isWebsitePublished: isJoyOwnedPage && isWebsiteV2Published,
  };
};
